import React from 'react';
import {
  Paper,
  Grid,
  CircularProgress,
  makeStyles,
  Button,
  colors,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import Routes from 'config/routes';

import Title from 'components/typography/Title';
import Description from 'components/typography/Description';

const useStyles = makeStyles({
  root: {
    padding: 32,
    marginTop: 64,
  },
  successfulButton: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  failedButton: {
    color: colors.grey[50],
    backgroundColor: colors.red[900],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const LogoutCard = ({
  isLoggingOut,
  hasLoggingOutFailed,
  hasLoggedOut,
  retry,
}) => {
  const classes = useStyles();

  return (
    <Paper elevation={4} className={classes.root}>
      <Grid container direction="column" spacing={5} alignItems="center">
        <Grid item>
          <Title>Logout</Title>
        </Grid>

        <Grid item>
          {isLoggingOut && (
            <CircularProgress
              style={{ color: colors.red[400] }}
            ></CircularProgress>
          )}
          {hasLoggedOut && <SuccessfulLogout></SuccessfulLogout>}
          {hasLoggingOutFailed && (
            <FailedLogout onRetryButtonPress={retry}></FailedLogout>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

const SuccessfulLogout = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Description align="center">
          <b style={{ color: colors.red[400] }}>Log out was successful</b>
        </Description>
      </Grid>

      <Grid item>
        <Link to={Routes.HOME_PAGE} style={{ textDecoration: 'none' }}>
          <Button variant="contained" className={classes.successfulButton}>
            GO TO HOME PAGE
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};

const FailedLogout = ({ onRetryButtonPress }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" alignItems="center" spacing={2}>
      <Grid item>
        <Description>
          <b style={{ color: colors.red[900] }}>Log out failed</b>
        </Description>
      </Grid>

      <Grid item>
        <Button
          variant="contained"
          className={classes.failedButton}
          onClick={onRetryButtonPress}
        >
          TRY AGAIN
        </Button>
      </Grid>
    </Grid>
  );
};

export default LogoutCard;
